<template>
    <div class="filter-wrapper">
        <p class="title">Manage Filters:</p>
        <div class="filter-container">
            <div class="filter-item">
                <date-range-picker :label="updated_at_label" :disabled="disabled" control-container-class="nice-select" opens="right" @select="getRange" @clear="clearRange"></date-range-picker>
            </div>
            <div class="filter-item">
                <select class="nice-select" v-model="filters.project_name" :disabled="disabled" @change="filter_list">
                    <option value="all">Job Name: All</option>
                    <option v-for="(opt,k) in jobnames" :key="k" :value="opt">{{ opt }}</option>
                </select>
            </div>
            <!-- <div class="filter-item" v-if="user.role == 'super_admin' || user.role == 'administrator' || user.role == 'project-manager'">
                <select class="nice-select" v-model="filters.subsidiary" :disabled="disabled" @change="filter_list">
                    <option value="all">Subsidiary: All</option>
                    <option v-for="(opt,k) in subsidiaries" :key="k" :value="opt">{{ opt }}</option>
                </select>
            </div> -->
            <div class="filter-item" v-if="user.role == 'super_admin' || user.role == 'administrator' || user.role == 'project-manager'">
                <select class="nice-select" v-model="filters.subsidiary" :disabled="disabled" @change="filter_list">
                    <option value="all">Subsidiary: All</option>
                    <option v-for="(opt,k) in companies" :key="k" :value="opt.username">{{ opt.company }}</option>
                </select>
            </div>
            <div class="filter-item" v-if="user.role == 'super_admin' || user.role == 'administrator'">
                <select class="nice-select" v-model="filters.region" :disabled="disabled" @change="filter_list">
                    <option value="all">Region: All</option>
                    <option v-for="(opt,k) in regions" :key="k" :value="opt">{{ opt }}</option>
                </select>
            </div>
            <div class="filter-item" v-if="user.role && (user.role == 'super_admin' || user.role == 'administrator' || user.role == 'project-manager' || user.role == 'super-user' || user.role.indexOf('ses-') != -1)">
                <select class="nice-select" v-model="filters.territory" :disabled="disabled" @change="filter_list">
                    <option value="all">Territory: All</option>
                    <option v-for="(opt,k) in territories" :key="k" :value="opt">{{ opt }}</option>
                </select>
            </div>
            <div class="filter-item" v-else>
                <select class="nice-select" v-model="filters.city" :disabled="disabled" @change="filter_list">
                    <option value="all">City: All</option>
                    <option v-for="(opt,k) in cities" :key="k" :value="opt">{{ opt }}</option>
                </select>
            </div>
            <div class="filter-item">
                <select class="nice-select" v-model="filters.state" :disabled="disabled" @change="filter_list">
                    <option value="all">State: All</option>
                    <option v-for="(opt,k) in states" :key="k" :value="opt">{{ opt }}</option>
                </select>
            </div>
            <div class="filter-item">
                <select class="nice-select" v-model="filters.start_date" :disabled="disabled" @change="filter_list">
                    <option value="all">Est Start: All</option>
                    <option v-for="(m,k) in months" :key="k" :value="(k+1) < 10 ? '0'+(k+1) : (k+1)">{{ m }}</option>
                </select>
            </div>
            <div class="filter-item" v-if="user.role == 'project-manager'">
                <select class="nice-select" v-model="filters.pm" :disabled="disabled" @change="filter_list">
                    <option value="all">PM: All</option>
                    <option v-for="(pm,sk) in pms" :key="sk" :value="pm">{{ pm }}</option>
                </select>
            </div>
            <div class="filter-item" v-if="showFilterCustomer">
                <select class="nice-select" v-model="filters.customer" :disabled="disabled" @change="filter_list">
                    <option value="all">Customer: All</option>
                    <option v-for="(cus, csk) in customers" :key="csk" :value="cus.id">{{ cus.username }}</option>
                </select>
            </div>
            <div class="filter-item">
                <select class="nice-select" v-model="filters.status" :disabled="disabled" @change="filter_list">
                    <option v-for="(stat,sk) in stats" :key="sk" :value="sk">{{ stat }}</option>
                </select>
            </div>
            <div class="filter-item response-filter" v-if="user.role == 'super_admin' || user.role == 'administrator'">
                <div class="nice-select">
                    <div>Res. Code: </div>
                    <select v-model="filters.project_awarded" :disabled="disabled" @change="filter_list">
                        <option value="all">Bid</option>
                        <option value="W">W</option>
                        <option value="L">L</option>
                        <option value="P">P</option>
                    </select>
                    <select v-model="filters.awarded_to_ses" :disabled="disabled" @change="filter_list">
                        <option value="all">Proposal</option>
                        <option value="Y">Y</option>
                        <option value="N">N</option>
                    </select>
                    <select v-model="filters.job_lost_reason" :disabled="disabled" @change="filter_list">
                        <option value="all">Reason</option>
                        <option value="C">C</option>
                        <option value="P">P</option>
                        <option value="F">F</option>
                        <option value="O">O</option>
                    </select>
                </div>
            </div>
            <div class="filter-item" v-if="user.role == 'super_admin' || user.role == 'administrator'">
                <date-range-picker :label="response_date_label" :disabled="disabled" control-container-class="nice-select" opens="left" @select="getResponseDateRange" @clear="clearResponseDateRange"></date-range-picker>
            </div>
            <div class="filter-item" v-if="user.role == 'super_admin' || user.role == 'administrator'">
                <select class="nice-select" v-model="filters.with_response_code" :disabled="disabled" @change="filter_list">
                    <option value="all">With Res. Code: All</option>
                    <option value="YES">YES</option>
                    <option value="NONE">NONE</option>
                </select>
            </div>
            <div class="filter-item" v-if="user.role == 'super_admin' || user.role == 'administrator'">
                <select class="nice-select" v-model="filters.pending_close" :disabled="disabled" @change="filter_list">
                    <option value="all">Pending Close: All</option>
                    <option value="YES">YES</option>
                    <option value="NO">NO</option>
                </select>
            </div>
            <div class="filter-item search-filter">
                <input type="text" placeholder="Search" v-model="filters.search" :disabled="disabled" @change="filter_list">
                <button type="button" :disabled="disabled" @click="filter_list"><i class="fa fa-search"></i></button>
            </div>
            <div class="filter-reset-btn">
                <a href="javascript:void(0)" :class="{ 'disabled-link': disabled }" title="Refresh" @click="reset_filter">
                    <i class="fa fa-refresh reset-icon" aria-hidden="true"></i>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
import DateRangePicker from '../components/DateRangePicker'
import moment from 'moment'

export default {
    components: {
        DateRangePicker
    },
    props: {
      status: {
        type: String,
        default: "all",
        description: "Status"
      },
      disabled: {
        type: Boolean,
        default: true
      }
    },
    data() {
        return {
            user: {},
            jobnames: [],
            subsidiaries: [],
            companies: [],
            regions: [],
            cities: [],
            territories: [],
            states: [],
            pms: [],
            months: ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'],
            stats: {
                all      : 'Status: Active',
                INITIAL  : 'INITIAL',
                FINAL    : 'FINAL',
                CLOSED   : 'CLOSED',
                VERIFIED : 'VERIFIED',
                PURCHASED: 'PURCHASED',
                PROCESSED: 'PROCESSED',
                SHIPPED  : 'SHIPPED',
                CUSTOM   : 'CUSTOM',
            },
            filters: {
                search: '',
                project_name: 'all',
                subsidiary: 'all',
                region: 'all',
                city: 'all',
                territory: 'all',
                state: 'all',
                start_date: 'all',
                status: this.status,
                updated_at: 'all',
                project_awarded: 'all',
                awarded_to_ses: 'all',
                job_lost_reason: 'all',
                response_date: 'all',
                with_response_code: 'all',
                pm: 'all',
                pending_close: 'all',
                customer: 'all'
            },
            updated_at_label: 'Date Submitted: All',
            response_date_label: 'Response Date: All',
            customers: [],
            showFilterCustomer: false
        }
    },
    watch: {
        status: {
            handler: function(data) {
                this.filters.status = data;
            }
        }
    },
    beforeMount(){
        var user = localStorage.getItem('user');
        if ( user ) this.user = JSON.parse(user);
        this.loadFilters();
    },
    methods: {
        loadFilters() {
            if(this.user.id != undefined) {
                this.$http.get(`/api/project-filters?user_id=${this.user.id}`).then((response) => {
                    if ( response.data.jobnames ) this.jobnames = response.data.jobnames;
                    if ( response.data.subsidiaries ) this.subsidiaries = response.data.subsidiaries;
                    if ( response.data.companies ) this.companies = response.data.companies;
                    if ( response.data.regions ) this.regions = response.data.regions;
                    if ( response.data.cities ) this.cities = response.data.cities;
                    if ( response.data.territories ) this.territories = response.data.territories;
                    if ( response.data.states ) this.states = response.data.states;
                    if ( response.data.customers.length > 0 ) {
                        this.customers = response.data.customers;
                        this.showFilterCustomer = true;
                    }
                    if ( response.data.pms ) {
                      this.pms = response.data.pms;
                      if (this.pms.includes(this.user.username)) {
                        this.filters.pm = this.user.username;
                      }
                    }
                    this.$emit('loaded', this.filters);
                });
            }
        },
        getRange(range) {
            this.filters.updated_at = moment(range.startDate).format('YYYY/MM/DD') + ' - ' + moment(range.endDate).format('YYYY/MM/DD')
            this.updated_at_label = this.filters.updated_at
            this.filter_list()
        },
        clearRange() {
            this.filters.updated_at = 'all'
            this.updated_at_label = 'Date Submitted: All'
            this.filter_list()
        },
        getResponseDateRange(range) {
            this.filters.response_date = moment(range.startDate).format('YYYY/MM/DD') + ' - ' + moment(range.endDate).format('YYYY/MM/DD')
            this.response_date_label = this.filters.response_date
            this.filter_list()
        },
        clearResponseDateRange() {
            this.filters.response_date = 'all'
            this.response_date_label = 'Response Date: All'
            this.filter_list()
        },
        filter_list() {
            this.$emit('filter', this.filters)
        },
        reset_filter() {
            this.filters = {
                search: '',
                project_name: 'all',
                subsidiary: 'all',
                region: 'all',
                city: 'all',
                territory: 'all',
                state: 'all',
                start_date: 'all',
                status: 'all',
                updated_at: 'all',
                project_awarded: 'all',
                awarded_to_ses: 'all',
                job_lost_reason: 'all',
                response_date: 'all',
                with_response_code: 'all',
                pm: 'all',
                pending_close: 'all',
                customer: 'all'
            }
            if (this.pms.includes(this.user.username)) {
              this.filters.pm = this.user.username;
            }
            this.updated_at_label = 'Date Submitted: All'
            this.response_date_label = 'Response Date: All'
            this.$emit('filter', this.filters)
        }
    }
}
</script>
<style lang="scss" scoped>
.response-filter {
    min-width: 260px !important;
    .nice-select {
        display: flex;
        align-items: center;
        font-size: 10px;
        text-transform: uppercase;
        select {
            background: none;
            border: 0;
            text-transform: uppercase;
        }
    }
}
.disabled-link {
  pointer-events: none !important;
}
@media (min-width: 1200px) {
    .ses-content .filter-wrapper .response-filter {
        width: 264px !important;
    }
}
</style>
